export const DEFAULT_MAP_LOCATION = [40.8951, -97.1384];
export const DEFAULT_CLOSEST_CITY_SLUG = "canada_ab_calgary";
export const DEFAULT_GEOLOCATION_LIMIT = 75000; // meters
export const NO_LOCATION_MAP_ZOOM_LEVEL = 3;
export const HAS_LOCATION_MAP_ZOOM_LEVEL = 12;
export const USE_VECTOR_MAP = false;
